import { constantRouterMap } from '@/router/index'
// function hasPermission(menus, route) {
//   if (route.name) {
//     const currMenu = getMenu(route.name, menus)
//     if (currMenu != null) {
//       if (currMenu.title != null && currMenu.title !== '') {
//         route.meta.title = currMenu.title
//       }
//       if (currMenu.icon != null && currMenu.title !== '') {
//         route.meta.icon = currMenu.icon
//       }
//       if (currMenu.hidden != null) {
//         route.hidden = currMenu.hidden !== 0
//       }
//       if (currMenu.sort != null && currMenu.sort !== '') {
//         route.sort = currMenu.sort
//       }
//       return true
//     } else {
//       route.sort = 0
//       if (route.hidden !== undefined && route.hidden === true) {
//         return true
//       } else {
//         return false
//       }
//     }
//   } else {
//     return true
//   }
// }

// function getMenu(name, menus) {
//   for (let i = 0; i < menus.length; i++) {
//     const menu = menus[i]
//     if (name === menu.name) {
//       return menu
//     }
//   }
//   return null
// }

// function sortRouters(accessedRouters) {
//   for (let i = 0; i < accessedRouters.length; i++) {
//     const router = accessedRouters[i]
//     if (router.children && router.children.length > 0) {
//       router.children.sort(compare('sort'))
//     }
//   }
//   accessedRouters.sort(compare('sort'))
// }

// function compare(p) {
//   return function(m, n) {
//     const a = m[p]
//     const b = n[p]
//     return b - a
//   }
// }

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: []
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers;
      state.routers = constantRouterMap.concat(routers);
    }
  },
  actions: {
    //   GenerateRoutes({ commit }, data) {
    //     return new Promise(resolve => {
    //       const { menus } = data
    //       // const { username } = data
    //       const accessedRouters = asyncRouterMap.filter(v => {
    //         if (hasPermission(menus, v)) {
    //           if (v.children && v.children.length > 0) {
    //             v.children = v.children.filter(child => {
    //               if (hasPermission(menus, child)) {
    //                 return child
    //               }
    //               return false
    //             })
    //             return v
    //           } else {
    //             return v
    //           }
    //         }
    //         return false
    //       })
    //       sortRouters(accessedRouters)
    //       commit('SET_ROUTERS', accessedRouters)
    //       resolve()
    //     })
    //   }
  }
}

export default permission




// WEBPACK FOOTER //
// ./src/store/modules/permission.js